import axiosInstance from '@/utils/api.js'

var state = {
  telZones: [],
  telZone: {
    'name': ''
  }
}

var getters = {
  TEL_ZONES: (state) => {
    return state.telZones
  },
  TEL_ZONE: (state) => {
    return state.telZone
  }
}

var mutations = {
  SET_TEL_ZONES: (state, payload) => {
    state.telZones = payload
  },
  SET_TEL_ZONE: (state, payload) => {
    state.telZone = payload
  }
}

var actions = {
  GET_TEL_ZONES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tel_zones')
    if (result.status === 200) {
      context.commit('SET_TEL_ZONES', result.data)
    }
  },
  GET_TEL_ZONE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/tel_zone?zone_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TEL_ZONE', result.data)
    }
  },
  CREATE_TEL_ZONES: (context, payload) => {
    return axiosInstance.post('/tariffing/tel_zone', payload)
  },
  UPDATE_TEL_ZONES: (context, payload) => {
    return axiosInstance.put('/tariffing/tel_zone', payload)
  },
  DELETE_TEL_ZONES: (context, payload) => {
    return axiosInstance.delete('/tariffing/tel_zone?zone_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/telZones.js